import React from 'react';
import * as R from 'ramda';
import FileSaver from 'file-saver';
import { pure, compose, withHandlers } from 'react-recompose';
// components
import { LocalLoader } from '../local-loader';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// ui
import { Box, AbsoluteBox } from '../../ui';
// component document-preview
import { FileViewerWrapper } from './ui';
import DocumentView from './document-view';
import { withAsyncFileOnDidMount } from './with-async-file';
//////////////////////////////////////////////////

const enhanceAsync = compose(
  withAsyncFileOnDidMount,
  withHandlers({
    handleDownload: (props) => () => (
      FileSaver.saveAs(
        props.asyncInitialData.data,
        R.path(['asyncOptions', 'params', GC.FIELD_FILE_NAME], props),
      )
    ),
  }),
  pure,
);

export const DocumentPreview = (props) => {
  const { filePath, fileType } = props;

  return (
    <Box width='100%' overflow='auto' position='static' height='calc(95vh - 30px)'>
      <FileViewerWrapper>
        <DocumentView filePath={filePath} fileType={R.or(fileType, GC.EXTENSION_PDF)} />
      </FileViewerWrapper>
    </Box>
  );
};

const darkBlue = G.getTheme('colors.dark.blue');

export const AsyncDocumentPreview = enhanceAsync((props) => {
  const { fileType, handleDownload, asyncInitialData } = props;

  const { data, loading } = asyncInitialData;

  let url = null;

  if (G.isNotNilAndNotEmpty(data)) url = window.URL.createObjectURL(data);

  return (
    <LocalLoader localLoaderOpen={R.and(loading, R.isNil(url))}>
      <Box width='100%' overflow='auto' position='static' height='calc(95vh - 30px)'>
        <FileViewerWrapper>
          <DocumentView filePath={url} fileType={R.or(fileType, GC.EXTENSION_PDF)} />
        </FileViewerWrapper>
        <AbsoluteBox
          p='8px'
          right={20}
          zIndex={11}
          bottom={20}
          color={darkBlue}
          cursor='pointer'
          border='1px solid'
          borderRadius='5px'
          borderColor={darkBlue}
          onClick={handleDownload}
          textTransform='uppercase'
          bg={G.getTheme('colors.white')}
        >
          {G.getWindowLocale('actions:download', 'Download')}
        </AbsoluteBox>
      </Box>
    </LocalLoader>
  );
});
